import React, { createContext, useContext, useState } from "react";
import {ROUTE_PREFIX, ROUTES} from "./utils/ModuleHelpers";
import {useHistory} from "react-router-dom";

const ModuleContext = createContext();

export function useModuleContext() {
  return useContext(ModuleContext);
}

export function ModuleProvider({ children }) {
  const history = useHistory();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [idForDelete, setIdForDelete] = useState(null);
  const [onDelete, setOnDelete] = useState({getEntities:()=>{}});
  const deleteModalProps = {
    deleteModalShow, idForDelete, onDelete, setOnDelete,
    openDeleteDialog: (id)=> { setIdForDelete(id); setDeleteModalShow(true); },
    closeDeleteDialog: ()=> { setIdForDelete(null); setDeleteModalShow(false); },
  }


  const value = {
    ...deleteModalProps,
    newButtonClick: ()=> { history.push(ROUTES.new.path); },
    listClick: ()=> { history.push(ROUTES.list.path); },
    openEditPage: (id)=> { history.push(`${ROUTE_PREFIX}/${id}/edit`); },
  };

  return (
    <ModuleContext.Provider value={value}>
      {children}
    </ModuleContext.Provider>
  );
}
